import CarEntity from "../../../../../domain/entities/CarEntity";
import CarImplDto from "../../../../dto/impl/CarImplDto";
import HostApi from "../../../../settings/HostApi";

const GetCarByIdApiImpl = async (id: string): Promise<CarEntity | undefined> => {
    if (id == "19") return undefined;
    const relativeUrl = `/v2/cars/${id}/`;
    try {
        const response = await HostApi.get(relativeUrl);
        return CarImplDto.fromJson(response);
    } catch (error) {
        return undefined;
    }
};

export default GetCarByIdApiImpl;
